// src/sessionKeepAlive.js
import { getTokens, setTokens } from "./api/api";

const API_BASE = process.env.REACT_APP_API_BASE || "/api";

// decode JWT exp
function getSecondsLeft(token) {
  try {
    const [, payload] = token.split(".");
    const { exp } = JSON.parse(atob(payload));
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, exp - now);
  } catch {
    return 0;
  }
}

async function refreshIfNeeded() {
  const { access, refresh } = getTokens();
  if (!access || !refresh) return;

  const secondsLeft = getSecondsLeft(access);
  // refresh if less than 5 minutes remain
  if (secondsLeft > 300) return;

  const res = await fetch(`${API_BASE}/token/refresh`, {
    method: "POST",
    headers: { Authorization: `Bearer ${refresh}` },
  });
  if (res.ok) {
    const data = await res.json();
    setTokens({ access: data.access_token, refresh: data.refresh_token });
  }
}

export function startSessionKeepAlive() {
  let lastActivity = Date.now();
  const markActive = () => { lastActivity = Date.now(); };

  ["mousemove", "keydown", "click", "scroll", "touchstart", "visibilitychange"].forEach(evt => {
    window.addEventListener(evt, markActive, { passive: true });
  });

  const interval = setInterval(async () => {
    const idleMs = Date.now() - lastActivity;
    const userIsActive = document.visibilityState === "visible" && idleMs < 2 * 60 * 1000; // active in last 2 min
    if (userIsActive) {
      try { await refreshIfNeeded(); } catch { /* ignore */ }
    }
  }, 60 * 1000); // check every minute

  return () => {
    clearInterval(interval);
    ["mousemove", "keydown", "click", "scroll", "touchstart", "visibilitychange"].forEach(evt => {
      window.removeEventListener(evt, markActive);
    });
  };
}
